<mat-menu #subMenu="matMenu" [overlapTrigger]="false" [xPosition]="'before'" [yPosition]="'below'">
  <ng-container *ngFor="let option of options">
    <span *ngIf="option.submenu && option.submenu.length > 0" routerLinkActive="dhl-horizontal-menu-active">
      <button
        mat-menu-item
        [matMenuTriggerFor]="menu.subMenu"
        [ngClass]="{ 'dhl-horizontal-menu-active': isChildRouteActive(option.submenu), '': !isChildRouteActive(option.submenu) }">
        <span>{{ option.menuName }}</span>
      </button>
      <dhl-menu-horizontal-item #menu [options]="option.submenu"></dhl-menu-horizontal-item>
    </span>
    <span *ngIf="!option.submenu || option.submenu.length === 0" [ngClass]="{ 'dhl-horizontal-menu-active': isCurrentUrl(option), '': !isCurrentUrl(option) }">
      <button mat-menu-item (click)="closeSidenav.emit()" [routerLink]="option.url" routerLinkActive="dhl-horizontal-menu-active" [routerLinkActiveOptions]="{ exact: true }">
        {{ option.menuName }}
      </button>
    </span>
  </ng-container>
</mat-menu>
